import { createContext, useContext } from 'react';

// Ð¡Ð°Ð¼ ÐºÐ¾Ð½ÑÐµÐºÑÑ Ð¸ ÑÑÐº Ðº Ð½ÐµÐ¼Ñ â Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾ Ð¾Ñ Ð¿ÑÐ¾Ð²Ð°Ð¹Ð´ÐµÑÐ°.
//
// ÐÑÐ¾Ð²Ð°Ð¹Ð´ÐµÑ ÑÐ¾Ð´Ð¸Ñ Ð½Ð° ÑÐµÑÐ²ÐµÑ, Ð° Ð·Ð½Ð°ÑÐ¸Ñ ÑÑÐ½ÐµÑ Ð·Ð° ÑÐ¾Ð±Ð¾Ð¹ Ð²ÐµÑÑ ÑÐ»Ð¾Ð¹ Ð·Ð°Ð¿ÑÐ¾ÑÐ¾Ð².
// ÐÐ°ÑÑÐ¾ÑÐºÐµ, ÑÐµÐº-Ð»Ð¸ÑÑÑ Ð¸ ÑÐ¾ÑÐºÐ°Ð¼-Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ°Ð¼ Ð½ÑÐ¶Ð½Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¾ÑÐ¸ÑÐ°ÑÑ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ,
// Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾Ð½Ð¸ Ð±ÐµÑÑÑ ÐµÐ³Ð¾ Ð¾ÑÑÑÐ´Ð° Ð¸ Ð¾ÑÑÐ°ÑÑÑÑ Ð»ÑÐ³ÐºÐ¸Ð¼Ð¸ â Ð¸Ñ Ð²Ð¸Ð´Ð½Ð¾ Ð² ÑÐµÑÑÐ°Ñ Ð±ÐµÐ·
// Ð¿Ð¾Ð´Ð½ÑÑÐ¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ.

const OnboardingContext = createContext(null);

// Ð¥ÑÐº ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð¸ Ð±ÐµÐ· Ð¿ÑÐ¾Ð²Ð°Ð¹Ð´ÐµÑÐ° â ÑÐ¾Ð³Ð´Ð° Ð¾ÑÐ´Ð°ÑÑ Ð·Ð°Ð³Ð»ÑÑÐºÑ. Ð¢Ð°Ðº ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾
// ÑÐµÐ½Ð´ÐµÑÐ¸ÑÑ Ð² ÑÐµÑÑÐµ, Ð½Ðµ Ð¾Ð±Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ñ ÐµÑ Ð² Ð¿ÑÐ¾Ð²Ð°Ð¹Ð´ÐµÑ.
const EMPTY = {
  available: false,
  tourRunning: false,
  startTour: () => {},
  finishTour: () => {},
  checklistDone: [],
  checklistHidden: true,
  completeChecklistItem: () => {},
  hideChecklist: () => {},
  restartOnboarding: () => {},
  allChecklistDone: false,
};

export const useOnboarding = () => useContext(OnboardingContext) || EMPTY;

export default OnboardingContext;
